import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
const modules = [{
  name: 'CJI',
  desc: 'Structured reasoning and judgment assessment.'
}, {
  name: 'NCJI Youth',
  desc: 'Developmental support for early education.'
}, {
  name: 'NCJI Pathways',
  desc: 'Workforce readiness and opportunity alignment.'
}, {
  name: 'NCJI Civic',
  desc: 'Community resilience and manipulation resistance.'
}, {
  name: 'NCJI Service',
  desc: 'Integrity and systems reasoning for the public sector.'
}, {
  name: 'NCJI Executive',
  desc: 'Crisis reasoning and governance readiness.'
}, {
  name: 'NCJI Atlas',
  desc: 'Aggregate capability mapping for institutions.'
}];
export function ProductEcosystem() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-1977" data-mp="2wmuec66x02v8">
      <div className="mb-12" data-id="element-1978" data-mp="30ofmxfcf1uzm">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1979" data-mp="30no12w8mfbmj">
          Assessment &amp; Development Modules
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1980" data-mp="ynwjy8zp8mul">
          Within the Human Capability Framework
        </h2>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1981" data-mp="tns3giysjs4d">
          The framework combines assessment methods, development pathways, and
          supporting services. These are proposed modules within CJI and NCJI. Each would
          require validation for its intended use before consequential
          application.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1982" data-mp="ay273rfdqyac">
        {modules.map(module => <li key={module.name} className="bg-surface-card p-6 rounded-lg border border-line flex flex-col h-full" data-id="element-1983" data-mp="60a5g5oxnxsy">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-1984" data-mp="1x41j4pamipn">{module.name}</h3>
            <p className="text-sm text-ink-muted" data-id="element-1985" data-mp="3t59iu1umqneq">{module.desc}</p>
          </li>)}
      </ul>

      <motion.div {...fadeUp} className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line pt-12" data-id="element-1986" data-mp="3jfjfsp7ikt9p">
        <div className="lg:col-span-5" data-id="element-1987" data-mp="39i4zcpllc4he">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1988" data-mp="39j6i7g8ulv9o">Noetivra · Coming soon</p>
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-tight" data-id="element-1989" data-mp="3egg8sz7z4cz3">
            Use the framework through Noetivra
          </h3>
        </div>
        <div className="lg:col-span-7" data-id="element-1990" data-mp="b09fnmn6py4k">
          <p className="text-lg text-ink-dark leading-relaxed mb-6" data-id="element-1991" data-mp="az7s4iozfj5y">
            Noetivra’s Human Capability Edition would provide the interactive
            workspace for completing tasks, reviewing findings, exploring
            development activities, and following progress over time. SKP would
            maintain the approved definitions, research, and versioned
            knowledge supporting that work.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-1992" data-mp="tt3jplj9s5u0">
            <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1993" data-mp="2ege4pkeihjkf">
              Human Capability Edition
              <ArrowRight size={16} aria-hidden="true" data-id="element-1994" data-mp="2j7mdqfbxj2x2" />
            </a>
            <a href="/semantic-knowledge" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1995" data-mp="2jaicg5vlpvmk">
              Semantic Knowledge Platform
              <ArrowRight size={16} aria-hidden="true" data-id="element-1996" data-mp="24kt7dzke17h0" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}